// Logo Satis Fiyati sayfasi. Swagger'da GET yok => gonderim odakli:
// yeni satir olustur -> kaydet -> Logo'ya POST. Gonderilenler oturum boyunca listede birikir.
import { ResourceListPage, ResourceConfig, FieldSpec } from '../components/ResourceListPage';
import { ItemSalesPrice, emptySalesPrice, LogoResult } from '../types';
import { saveSalesPrice } from '../api/item-prices';

// Oturum ici yerel liste (GET olmadigi icin gonderilenleri gostermek adina).
let seq = 0;
const store: Array<ItemSalesPrice & { _key: number }> = [];

const columns = [
  { dataField: 'cardCode', caption: 'Malzeme Kodu', width: 150 },
  { dataField: 'clientCode', caption: 'Cari', width: 130 },
  { dataField: 'price', caption: 'Fiyat', width: 110, alignment: 'right' as const, dataType: 'number' as const },
  { dataField: 'unitCode', caption: 'Birim', width: 90 },
  { dataField: 'vatIncl', caption: 'KDV Dahil', width: 100, alignment: 'center' as const,
    cellRender: (d: any) => (d.data.vatIncl ? 'Evet' : 'Hayir') },
  { dataField: 'dateBegin', caption: 'Baslangic', width: 120 },
  { dataField: 'dateEnd', caption: 'Bitis', width: 120 },
  { dataField: 'definition', caption: 'Aciklama', width: 'auto' },
];

const fields: FieldSpec[] = [
  { field: 'cardCode', label: 'Malzeme Kodu', required: true, tab: 'Genel' },
  { field: 'clientCode', label: 'Cari Kodu', tab: 'Genel' },
  { field: 'price', label: 'Fiyat', editor: 'number', required: true, tab: 'Genel' },
  { field: 'currency', label: 'Doviz', editor: 'number', tab: 'Genel' },
  { field: 'vatIncl', label: 'KDV Dahil', editor: 'check', tab: 'Genel' },
  { field: 'unitCode', label: 'Birim', tab: 'Genel' },
  { field: 'priority', label: 'Oncelik', editor: 'number', tab: 'Genel' },
  { field: 'dateBegin', label: 'Baslangic Tarihi', editor: 'date', tab: 'Genel' },
  { field: 'dateEnd', label: 'Bitis Tarihi', editor: 'date', tab: 'Genel' },
  { field: 'definition', label: 'Aciklama', colSpan: 2, tab: 'Genel' },

  { field: 'paymentCode', label: 'Odeme Plani', tab: 'Ticari' },
  { field: 'shipmentType', label: 'Sevkiyat Tipi', editor: 'number', tab: 'Ticari' },
  { field: 'tradingGroup', label: 'Ticari Grup', tab: 'Ticari' },
  { field: 'groupCode', label: 'Grup Kodu', tab: 'Ticari' },
  { field: 'orgLogoId', label: 'Org Logo Id', tab: 'Ticari' },
  { field: 'orderNr', label: 'Sira No', editor: 'number', tab: 'Ticari' },
  { field: 'cyphCode', label: 'Sifre Kodu', tab: 'Ticari' },
  { field: 'extAccFlags', label: 'ExtAccFlags', editor: 'number', tab: 'Ticari' },

  { field: 'arpTradingGroup', label: 'Cari Ticari Grup', tab: 'Cari' },
  { field: 'arpAuthCode', label: 'Cari Yetki Kodu', tab: 'Cari' },
  { field: 'arpCyphCode', label: 'Cari Sifre Kodu', tab: 'Cari' },
  { field: 'arpSpecode1', label: 'Cari Ozel Kod 1', tab: 'Cari' },
  { field: 'arpSpecode2', label: 'Cari Ozel Kod 2', tab: 'Cari' },
  { field: 'arpSpecode3', label: 'Cari Ozel Kod 3', tab: 'Cari' },
  { field: 'arpSpecode4', label: 'Cari Ozel Kod 4', tab: 'Cari' },
  { field: 'arpSpecode5', label: 'Cari Ozel Kod 5', tab: 'Cari' },
];

const config: ResourceConfig<ItemSalesPrice & { _key: number }> = {
  keyExpr: '_key',
  columns,
  fields,
  load: async () => ({ ok: true, data: [...store] } as LogoResult<any>),
  save: async (p) => {
    const res = await saveSalesPrice(p);
    if (res.ok) store.push({ ...p, _key: ++seq });
    return res;
  },
  newItem: () => ({ ...emptySalesPrice(), _key: 0 }),
  headerLabel: (p) => (p.cardCode ? `${p.cardCode} — ${p.price}` : 'Yeni Satis Fiyati'),
};

export default function LogoSalesPricesPage() {
  return <ResourceListPage config={config} />;
}
